import React from 'react';
import Button, { Themes } from 'ui/Button/Button';
import ModalWindow from '../ModalWindow/ModalWindow';
import { IModalProps } from '../IModalProps';

import styles from './ErrorModal.module.css';

import cross from 'assets/icons/fail.png';

interface Props {
  onCloseText?: string;
}

const ErrorModal = ({ open, onClose, children, onCloseText }: Props & IModalProps) => {
  const statusMap = {
    icon: cross,
    secondaryBtnText: null,
    btnText: onCloseText || 'Close',
  };

  if (!open) {
    return null;
  }

  const content = (
    <section className={styles.content}>
      <div className={styles.statusInfo}>
        <div className={styles.statusRingOuter}>
          <div className={styles.statusRingInner}>
            <img alt="error" src={statusMap.icon} />
          </div>
        </div>
        <p className={styles.message}>{children}</p>
      </div>
      <div>
        <Button onClick={onClose} theme={Themes.primary} className={styles.button} fullWidth>
          {statusMap.btnText}
        </Button>
      </div>
    </section>
  );

  return (
    <ModalWindow open={open} onClose={onClose} fullScreen>
      {content}
    </ModalWindow>
  );
};

export default ErrorModal;
